import { makeStyles } from '@mui/styles';
import { colors } from '../../theme/Theme';

export const useStyles = makeStyles({
  email: {
    marginTop: 6,
  },
  login: {
    marginBottom: 8,
    textAlign: 'left',
    fontFamily: 'Roboto',
    fontWeight: 500,
  },
  submitBtn: {
    color: 'white',
  },
  label: {
    textAlign: 'left',
  },
  labelCenter: {
    textAlign: 'center',
  },
  footer: {
    marginTop: 16,
  },
  loginBtn: {
    color: colors.grey600,
    textDecoration: 'underline',
    textTransform: 'none',
    fontWeight: 'bold',
    paddingLeft: 5,
  },
});
